<template>
  <div>
    <TCheckbox
      :model-value="selectionState === 'all' ? true : false"
      :indeterminate="selectionState === 'some'"
      @update:model-value="
        (value) => {
          value ? bulkEdit.selectAll() : bulkEdit.deselectAll();
        }
      "
    />
  </div>
</template>
<script setup lang="ts">
import { injectOrFail } from '@teachino/shared-util';
import { computed } from 'vue';
import TCheckbox from '../TCheckbox.vue';
import { bulkEditInjectionKey } from './bulk-edit';

type SelectionState = 'all' | 'some' | 'none';

const bulkEdit = injectOrFail(
  bulkEditInjectionKey,
  'This component can only be used inside a BulkEditGroup',
);

const selectionState = computed<SelectionState>(() => {
  const selectionCount = bulkEdit.selection.value.length;
  const itemCount = bulkEdit.items.value.length;

  if (selectionCount === 0) {
    return 'none';
  }
  if (selectionCount === itemCount) {
    return 'all';
  }
  return 'some';
});
</script>
